import { inject, InjectionToken } from '@angular/core';
import { WINDOW } from '@personal-area/common';
import { StorageFactory } from 'libs/storage/src/lib/utils/storage-factory';

export const LOCAL_STORAGE = new InjectionToken<Storage>('Global local storage', {
  factory: (): Storage => inject(WINDOW)?.localStorage ?? StorageFactory.localStorage,
});
